module.exports = __webpack_public_path__ + "static/pie2-c7c82a718aacf5dc893a42da7d3388a3.png";